"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterTypeGroupSchema = void 0;
exports.MasterTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/master.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MasterTypeGroup",
    "description": "MasterTypeGroup represents one of the following types: AppleImmersiveVideoMaster, AudioClipMaster, AudioEpisodeMaster, AudioSeasonMaster, AudioSeriesMaster, AuthorProfileMaster, ContentCollectionMaster, EditorialListMaster, EnergyDrinkMaster, EpisodeVideoMaster, EventDetailMaster, EventProfileMaster, EventSeasonMaster, EventSeriesMaster, ExternalPersonMaster, ExternalTeamMaster, ExternalContentMaster, FilmMaster, ImageGalleryMaster, ImageMaster, Immersive3DModelMaster, JudgeMaster, LiveVideoMaster, LocationMaster, MiscMaster, OccasionCampaignMaster, OccasionMaster, OnsitePromotionMaster, PartnerProfileMaster, PersonProfileMaster, PhotographerMaster, PlaylistMaster, PreviewClipMaster, ProjectProfileMaster, RallyDriverMaster, RallyTeamMaster, RecapVideoMaster, ResultsAndStandingsMaster, SeasonMaster, ShowMaster, StoryMaster, TagMaster, TeamProfileMaster, TrailerVideoMaster, TvCommercialMaster, TvPartnerChannelMaster, Video3DMaster, VideoChannelMaster, VideoMaster, Video360Master",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/audio-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/audio-episodes.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/audio-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/audio-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/author-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/collections.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/editorial-lists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/energy-drinks.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/event-details.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/event-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/event-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/event-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/external-persons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/external-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/externals.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/image-galleries.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/images.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/immersive-3d-models.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/judges.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/live-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/locations.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/misc.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/occasion-campaigns.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/occasions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/onsite-promotions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/partner-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/person-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/photographers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/playlists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/preview-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/project-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/rally-drivers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/rally-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/results-standings.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/shows.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/stories.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/tags.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/team-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/tv-commercials.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/tv-partner-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/video-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/master/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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